import React, { useCallback, useEffect, useState } from "react";
import PaginatedTable from "../../common/PaginatedTable";
import { Col, Input, Row, Select } from 'antd';
import {
    SearchOutlined, EyeOutlined
} from "@ant-design/icons";
import './support.less';
import { Link, useLocation, useHistory } from "react-router-dom";
import {
    ApiHelper,
    message as cMessage,
    getUserData,
  } from "../../../utils/Helpers";
  import { messages } from "../../../utils/Common/Messages";
  import { ApiRoutes } from "../../../utils/Config/ApiRoutes";

import AxiosService from "../../../utils/Config/ApiService";
import SupportLoader from "../../../utils/Config/SupportLoader"
import Nodata from "../../../assets/images/support/nodata.png";

const Support = () => {

    const [pageloader, setpageloader] = useState(true)
    const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
    const [merchantSearchKey, setMerchantSearchKey] = useState('');
const [staffSearchKey, setStaffSearchKey] = useState('');

    let [addToggle, setAddToggle] = useState(false);
    let [viewToggle, setViewToggle] = useState(false);
    let [totalCount, setTotalCount] = useState(0)
    let [currentPage, setCurrentPage] = useState(1)
    let [itemsPerPage, setItemsPerPage] = useState(10)
    let [searchKey, setSearchKey] = useState("")
    let [users, setUsers] = useState([]);
    let [staffs, setstaffs] = useState([])
    let [merchants, setmerchants] = useState([])
    let [userid, setuserid] = useState("")
    let [statusFilter, setStatusFilter] = useState("All");

    let [isLoading, setIsLoading] = useState(true)
    let [isloader, setisloader] = useState(false)
    let [params, setparams] = useState("")
    let [isstaff, setisstaff] = useState(false)
    let [ismerchant, setismerchant] = useState(false)
    let [store, setstore] = useState([])
    let {search} = useLocation()
    let history = useHistory()
    //useState is required if we need column filter
    const [column, setColumn] = useState([])
    const location = useLocation()

    const merchantColumn = [
        {
            heading: () => '#',
            cell: (row, i) => {
                return i;
            },
            hidden: false,
            width: "20",
            id: 1
        },
        {
            heading: () => "Date",
            cell: row => {
                const date  = new Date(row['date']).toString().slice(4,15)
                const requiredDate = date.substring(0,6)+","+date.substring(7)
                return requiredDate;
            },
            hidden: false,
            width: "100",
            id: 2
        },
        {
            heading: () => "Onboarders",
            cell: row => row['onboarders'],
            hidden: false,
            width: "120",
            id: 3
        },
        {
            heading: () => "Merchant Organization",
            cell: row => row['organizationName'],
            hidden: false,
            width: "100",
            id: 6
        },
        {
            heading: () => "Country",
            cell: row => row['countryName'],
            hidden: false,
            width: "100",
            id: 7
        },
        {
            heading: () => "Type",
            cell: row => row['type'],
            hidden: false,
            width: "100",
            id: 8
        },
        {
            heading: () => "Status",
            cell: row => {
                
                if(row['active'] === 1){
                    return  <span style={{color : "#488f42" , backgroundColor: "#ebfce3", paddingLeft:"4px",paddingRight : "4px", fontWeight: "600"}}>Active</span>
                  }else if(row['active'] === 0){
                    return <span style={{color : "#eb5f50" , backgroundColor: "#ffeceb", paddingLeft:"4px", paddingRight : "4px",fontWeight: "600"}}>Inactive</span>
                  }
            },
            hidden: false,
            width: "100",
            id: 9
        },

        {
            heading: () => "Actions",
            cell: row => {
                sessionStorage.setItem("ismerchant", ismerchant)
                sessionStorage.setItem("searchKey", merchantSearchKey)
                return <>
                    {
                        row['type']==='Merchant'?<Link to = {ismerchant ? `/support/merchant/${row?.organizationId}` : "/support"} className="btn--small btn--view"><EyeOutlined /></Link>
                        :row['type']==='Location'?<Link to = {ismerchant ? `/support/store/${row?.organizationId}` : "/support"} className="btn--small btn--view"><EyeOutlined /></Link>:<></>
                    }
                </>
            },
            hidden: false,
            width: "20",
            id: 14
        }

    ]

    const staffsColumn = [
        {
            heading: () => '#',
            cell: (row, i) => {
                return i;
            },
            hidden: false,
            width: "20",
            id: 1
        },
        {
            heading: () => "User ID",
            cell: row => row['userid'],
            hidden: true,
            width: "120",
            id: 2
        },
        {
            heading: () => "Username",
            cell: row => row['userName'],
            hidden: false,
            width: "120",
            id: 3
        },
        {
            heading: () => "Email",
            cell: row => row['email'],
            hidden: false,
            width: "100",
            id: 4
        },
        {
            heading: () => "Phone Number",
            cell: row => row['businessPhone'],
            hidden: false,
            width: "100",
            id: 5
        },
        {
            heading: () => "Merchant/Location Name",
            cell: row => row['organizationName'],
            hidden: false,
            width: "100",
            id: 6
        },
        {
            heading: () => "Category",
            cell: row => row['type'],
            hidden: false,
            width: "100",
            id: 7
        },
        {
            heading: () => "Actions",
            cell: row => {
                sessionStorage.setItem("searchKey", staffSearchKey)
                sessionStorage.setItem("isstaff", isstaff)
                return <><Link to= {row?.type === 'Merchant' ? `/support/merchant/${row?.organizationId}` : 
                row?.type === 'Location' ? `/support/store/${row?.organizationId}`:
                row?.type === 'Location Staff' ? `/support/store/staff/${row?.employeeId}`:
                row?.type === 'Admin Staff' ? `/support/adminStaffProfile/${row?.employeeId}`:
                <></>}className="btn--small btn--view"><EyeOutlined /></Link></>
            },
            hidden: false,
            width: "20",
            id: 8
        }

    ]

    const verifyToken = async()=>{
        let query = new URLSearchParams(search)
        let token;
        if(query.get('token'))
        {
            token = query.get('token')
            sessionStorage.setItem('token',query.get('token'))
        }
        else
        {
            token = sessionStorage.getItem('token')
        }

        if(token)
        {
            try {
                let res = await AxiosService.post(`${ApiRoutes.SUPPORT_VERIFY_TOKEN.service}${ApiRoutes.SUPPORT_VERIFY_TOKEN.url}`,{token})
                if(res.status===200)
                {
                    sessionStorage.setItem('userData',JSON.stringify(res.data.userData))
                    sessionStorage.setItem('supportToken',(res.data.token))
                    history.push('/support')
                }
                else
                {
                    
                }
            } catch (error) {
                if(error.response.status===400)
                {
                    alert('Session Expired')
                    history.push('/')
                }
                else
                {
                    alert('Error Occoured. Login Again')
                    history.push('/')
                }
            }
        }
        else
        {
            alert('No token found')
            history.push('/')
        }
    }

    const getStaffsList = useCallback(  async() => {
       
        try{
            const response = await AxiosService.get(`${ApiRoutes.STAFFS.service}${ApiRoutes.STAFFS.url}`,{
                params : {
                    pgno : currentPage,
                    limit : itemsPerPage,
                    searchKey : searchKey
                }
            } 
          );
    
            if(response.status === 200){
                setisloader(false)
                setstaffs(response.data.data)
                setTotalCount(response.data.count)
                setIsLoading(true)
                setpageloader(false)
                // sessionStorage.removeItem("searchKey")
                sessionStorage.removeItem("ismerchant")
                
            }
        }catch(error){
            console.log(error)
        }
    },[currentPage, itemsPerPage, searchKey, isloader, staffSearchKey]

    )
    const getMerchantList = useCallback( async() => {
        try{
            const response = await AxiosService.get(`${ApiRoutes.MERCHANTS.service}${ApiRoutes.MERCHANTS.url}`,{
                params : {
                    pgno : currentPage,
                    limit : itemsPerPage,
                    searchKey : isstaff ? staffSearchKey : ismerchant ? merchantSearchKey : ""
                }
            } 
          );
    
            if(response.status === 200){
                setisloader(false)
                setmerchants(response.data.data)
                setTotalCount(response.data.count)
                setIsLoading(true)
                setpageloader(false)
                sessionStorage.removeItem("isstaff")

                
            }
        }catch(error){
            console.log(error)
        }
    },[currentPage, itemsPerPage, searchKey, isloader, merchantSearchKey])

    useEffect(()=>{
        verifyToken()
    },[])

    useEffect(() => {
        if(searchKey === ""){
            setismerchant(false)
            setisstaff(false)
        } 
        if(ismerchant && searchKey !== ""){
            // setisloader(true)
            getMerchantList()
            setColumn(merchantColumn)

        }else if(isstaff && searchKey !== ""){
            // setisloader(true)
            getStaffsList()
            setColumn(staffsColumn)
        }
        if (ismerchant && merchantSearchKey?.length === 0) {
          sessionStorage.setItem("searchKey", "");
          setismerchant(false)

        }
        if (isstaff && staffSearchKey?.length === 0) {
          sessionStorage.removeItem("searchKey", "");
          setisstaff(false)
        }

        
    },[currentPage, itemsPerPage, staffSearchKey, merchantSearchKey, ismerchant, isstaff, isloader])

    useEffect(() =>{
        if(sessionStorage.getItem("isstaff") && sessionStorage.getItem("searchKey") !== null){
            setStaffSearchKey(sessionStorage.getItem("searchKey"))
            setSearchKey(sessionStorage.getItem("searchKey"))
            setMerchantSearchKey("")

            setColumn(staffsColumn)
            setIsLoading(false)
            setismerchant(false)
            setisstaff(true)
            setpageloader(true)

            setisloader(false)

        }
        if(sessionStorage.getItem("ismerchant") && sessionStorage.getItem("searchKey") !== null){
            setMerchantSearchKey(sessionStorage.getItem("searchKey"))
            setSearchKey(sessionStorage.getItem("searchKey"))
            setStaffSearchKey('')

            setColumn(merchantColumn)
            setIsLoading(false)               
            setismerchant(true)
            setisstaff(false)
            setpageloader(true)

            setisloader(false)

        }
    },[])


    //stores
const pageNumberLimit = 3



// console.log("process.env.REACT_APP_LIVE_URL",process.env.REACT_APP_LIVE_URL)

    return (<div>
 
         <div className="adminContentSection">
        <Row gutter={8}>
            <Col span={10}            >
                {/* <span  style={{  opacity: (ismerchant && !isstaff)  ? "0.5" : ""}} > */}

                <Input size="large"
                disabled ={staffSearchKey?.length !==0}
                id="merchant"
                placeholder="Merchant search by Onboarders, Merchant Organization" 
                prefix={<SearchOutlined />} 
                className="supportSearchBox"
                style={{
                    opacity: !ismerchant && isstaff ? 0.5 : 1
                  }}
             
                value={merchantSearchKey}
                onClick={() =>{
                    // setisloader(true)
                    // setSearchKey("")
                      setTotalCount(0)
                    // getMerchantList()
                }}
                onChange={(e) => {
                    const regex = /^[ ]/g
                    if(regex.test(e.target.value)){
                        e.target.value?.replace(/^[ ]/g,"")
                    }else{
                        setStaffSearchKey('')

                        setColumn(merchantColumn)
                        setIsLoading(false)               
                        setismerchant(true)
                        setisstaff(false)
                        setpageloader(true)
                        setSearchKey(e.target.value)
                        setMerchantSearchKey(e.target.value)
                    }

                }}
                    

                 />
              
            </Col>
            <Col span={10}  >
                {/* <span style={{  opacity: (!ismerchant && isstaff)  ? "0.5" : ""}}> */}

                <Input size="large"
                disabled ={merchantSearchKey?.length !==0}
                 value = {staffSearchKey}
                id="staff"
                placeholder="Staff Search By Username, Email, Phone no" 
                prefix={<SearchOutlined />} 
                className="supportSearchBox" 
                style={{
                    opacity: ismerchant && !isstaff ? 0.5 : 1
                  }}
               
                onClick={(e) =>{
                    // setisloader(true)
                    // setSearchKey("")

                    setTotalCount(0)
                    // getStaffsList()
                }}

                onChange={(e) => {
                    const regex = /^[ ]/g
                    if(regex.test(e.target.value)){
                        e.target.value?.replace(/^[ ]/g,"")
                    }else{
                    setMerchantSearchKey("")

                    setColumn(staffsColumn)
                    setIsLoading(false)
                    setismerchant(false)
                    setisstaff(true)
                    setpageloader(true)
                    setSearchKey(e.target.value)
                    setStaffSearchKey(e.target.value)
                    }
                  
                    
                }}
                />
          
            </Col>
            {/* <Col span={4}>
                    <Select
                           defaultValue={itemsPerPage}
                        style={{ width: '100%' }}
                        className="selectPicker"
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                            setMaxPageNumberLimit(pageNumberLimit);
                            setMinPageNumberLimit(0);
                        }}
                        options={[
                            {
                                value: '10',
                                label: '10',
                            },
                            {
                                value: '20',
                                label: '20',
                            },
                            {
                                value: '50',
                                label: '50',
                            },
                            {
                                value: '100',
                                label: '100',
                            },
                        ]}
                    />
                </Col> */}
            <Col span={4}>
                    <div>

 
        <select
        style={{width : "85%"}}
        defaultValue={itemsPerPage}
        onChange={(e) => {
            setItemsPerPage(Number(e.target.value));
            setCurrentPage(1);
            setMaxPageNumberLimit(pageNumberLimit);
            setMinPageNumberLimit(0);
        }}
        >
  <option value={5}>5</option>
  <option value={10}>10</option>
  <option value={25}>25</option>
  <option value={50}>50</option>
  <option value={100}>100</option>
</select>
&nbsp; 
</div>
            </Col>

        </Row>
        

        
        {
           (!isstaff && staffSearchKey?.length === 0) && (!ismerchant && merchantSearchKey?.length === 0) ? <div className="text-center p-x8-y16 bg-white mt30"><img src={`data:image/png;base64,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`} alt='icon'/> </div> : <></> 
        }
        {
           isloader ? <SupportLoader/> :
            ((staffSearchKey?.length !== 0) || ( merchantSearchKey?.length !== 0))? <PaginatedTable
            row={isstaff ? staffs :
                 ismerchant ? merchants : []
            }
            column={column}
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            searchKey={ staffSearchKey?.length > 0 ? staffSearchKey : merchantSearchKey?.length > 0 ? merchantSearchKey  : ""}
            setSearchKey={setSearchKey}
            isFilterHeader={false}
            isSearch = {false}
            maxPageNumberLimit={maxPageNumberLimit}
            setMaxPageNumberLimit={setMaxPageNumberLimit}
            minPageNumberLimit={minPageNumberLimit}
            setMinPageNumberLimit={setMinPageNumberLimit}
            isloader = {isloader}
            setpageloader={setpageloader}
            pageloader={pageloader}
            isvisible = {false}
            
        /> : <div style={{ textAlign: "center" }}></div>
        }

    </div>
        
        
    </div>
       
    );
}

export default Support;